import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  FMFByID,
  FMFListQueryParam,
  FMFModels,
  FMFSizes,
  FetchFMFListResponse,
  fmfFormValue,
} from '@shared/models';
import { Observable, map, of } from 'rxjs';

import { buildHttpParamsFromQueryParams } from '@shared/utils';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FMFService {
  _http = inject(HttpClient);
  _apiUrl = environment.apiUrl;
  _authHeaders = new HttpHeaders({
    Authorization: '',
  });

  fetchFMFOrders(
    queryParams?: Partial<FMFListQueryParam>
  ): Observable<FetchFMFListResponse> {
    const queryParamsMapped = {
      id: queryParams?.id,
      patientFullname: queryParams?.patientFullname,
      product: 'FMF',
      establishment: queryParams?.institution,
      email: queryParams?.email,
      phone_number: queryParams?.phone,
      order_by: queryParams?.order_by,
      order_direction: queryParams?.order_direction,
      page: queryParams?.page,
      per_page: queryParams?.per_page,
    };
    const params = buildHttpParamsFromQueryParams(queryParamsMapped);

    return this._http.get<FetchFMFListResponse>(
      `${this._apiUrl}/api/order/list`,
      {
        headers: this._authHeaders,
        params,
      }
    );
  }

  fetchFMFByID(id: number): Observable<FMFByID> {
    const fakeFMF: FMFByID = {
      id: id,
      status: 'En curso',
      creationDate: new Date('2023-09-27T03:00:00.000Z'),
      institutionId: 1,
      clientFullname: 'Doctor Álvarez',
      patientFullname: `Paciente ${id}`,
      patientBirthdate: '10-06-1999',
      patientPhoneNumber: '15123123',
      patientIdNumber: '40.300.780',
      patientAddress: 'San Martin 1810',
      patientEmail: 'mock1@gmail.com',
      patientGender: 'Femenino',
      patientHealthPlan: 'OSDE',
      patientIdCard: '123345678',
      chestPerimeter: 40,
      correctionPressure: 10,
      PCPosition: '12',
      model: 'B-14 Fast Lock',
      mammaryDevelopment: 'Mínimo/Nulo (pad simple)',
      size: 1,
      observations: 'Todo listo para operar',
    };
    return of(fakeFMF);
    // return this._http
    //   .get<FetchFMFByIDResponse>(`${this._apiUrl}/api/order/${id}`, {
    //     headers: this._authHeaders,
    //   })
    //   .pipe(map((resp) => resp.FMF));
  }
  fetchFMFModels() {
    return this._http
      .get<{ data: FMFModels[] }>(`${this._apiUrl}/api/order/fmf/models`, {
        headers: this._authHeaders,
      })
      .pipe(map((response) => response.data));
  }
  fetchFMFSizes() {
    return this._http
      .get<{ data: FMFSizes[] }>(`${this._apiUrl}/api/order/fmf/sizes`, {
        headers: this._authHeaders,
      })
      .pipe(map((response) => response.data));
  }

  createFMF(value: fmfFormValue) {
    const payload = {
      institution_id: value.institutionId,
      patient_id: value.patientId,
      creation_date: value.creationDate ? value.creationDate.toISOString() : '',
      status: value.status,
      chest_perimeter: value.chestPerimeter,
      correction_pressure: value.correctionPressure,
      pc_position: value.pcPosition,
      model: value.model,
      size: value.size,
      mammary_development: value.mammaryDevelopment,
      observation: value.observations ?? '',
    };
    return this._http.post(`${this._apiUrl}/api/order/create-fmf`, payload, {
      headers: this._authHeaders,
    });
  }

  updateFMF(value: fmfFormValue, id: number) {
    const payload = {
      institutionId: value.institutionId,
      patientId: value.patientId,
      creationDate: value.creationDate ? value.creationDate.toISOString() : '',
      status: value.status,
      chestPerimeter: value.chestPerimeter,
      correctionPressure: value.correctionPressure,
      pcPosition: value.pcPosition,
      model: value.model,
      size: value.size,
      mammaryDevelopment: value.mammaryDevelopment,
      observations: value.observations ?? '',
    };
    return this._http.patch(
      `${this._apiUrl}/api/order/update-fmf/${id}`,
      payload,
      {
        headers: this._authHeaders,
      }
    );
  }

  removeFMFByID(id: number) {
    return this._http.delete(`${this._apiUrl}/api/order/delete-fmf/${id}`, {
      headers: this._authHeaders,
    });
  }
}
